import { computed, type MaybeRefOrGetter, onUnmounted, ref, toValue, watch } from "vue";

const DEFAULT_PHRASE_INTERVAL = 2600;

export function useRotatingPhrases(
	phrases: MaybeRefOrGetter<string[]>,
	interval: MaybeRefOrGetter<number | null | undefined>,
	active: MaybeRefOrGetter<boolean>,
) {
	const index = ref(0);
	let timer: ReturnType<typeof setInterval> | null = null;

	const phrase = computed(() => {
		const list = toValue(phrases);
		return list.length ? (list[index.value % list.length] as string) : "";
	});

	const stop = () => {
		if (!timer) return;
		clearInterval(timer);
		timer = null;
	};

	const start = () => {
		stop();
		if (toValue(phrases).length < 2) return;

		timer = setInterval(() => {
			index.value = (index.value + 1) % toValue(phrases).length;
		}, toValue(interval) || DEFAULT_PHRASE_INTERVAL);
	};

	watch(
		[() => toValue(active), () => toValue(interval), () => toValue(phrases).length],
		([isActive]) => {
			if (!isActive) {
				stop();
				index.value = 0;
				return;
			}
			start();
		},
		{ immediate: true },
	);

	onUnmounted(stop);

	return { phrase, index };
}
